module.exports = __webpack_public_path__ + "img/ico-mejorplataforma.d3200dcf.svg";